import React, { Component } from 'react';
import { Button, Row, Col, FormGroup, Input } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';

import { SignUpLink } from '../SignUp';
import { SignUpForm } from '../SignUp';
import { PasswordForgetLink } from '../PasswordForget';
import { withFirebase } from '../Firebase';
import * as ROUTES from '../../constants/routes';

import MenuPrincipal from '../../menu/menuPrincipal';
import Rodape from "../../rodape/rodape";

import './index.css';

const SignInPage = () => (
    <div>
        <MenuPrincipal />
        <header className="masthead">
            <div className="container h-100">
                <div className="row h-100 align-items-center justify-content-center text-center">
                    <div className="col-lg-10 align-self-end">
                        <img src="img/logoExpertRedondo.png" />
                        <h1 className="text-white font-weight-bold">Entrar</h1>
                    </div>
                    <div className="col-lg-8 align-self-baseline">
                        <SignInGoogle />
                        <SignInFacebook />
                        <SignInForm />
                        <SignUpLink />
                    </div>

                </div>
            </div>
        </header>
        <Rodape />
    </div>
);

const INITIAL_STATE = {
    email: '',
    password: '',
    error: null,
};

class SignInGoogleBase extends Component {
    constructor(props) {
        super(props);

        this.state = { error: null };
    }

    onSubmit = event => {
        this.props.firebase
            .doSignInWithGoogle()
            .then(socialAuthUser => {

                return this.props.firebase
                    .user(socialAuthUser.user.uid)
                    .set({
                        username: socialAuthUser.user.displayName,
                        email: socialAuthUser.user.email,
                        url: socialAuthUser.user.photoURL,
                    });
            })
            .then(socialAuthUser => {
                this.setState({ error: null });
                this.props.history.push(ROUTES.MEUS_DADOS);
            })
            .catch(error => {
                this.setState({ error });
                this.props.history.push(ROUTES.MEUS_DADOS);
            });

        event.preventDefault();
    };

    render() {
        const { error } = this.state;

        return (
            <form onSubmit={this.onSubmit}>
                <Button outline color="primary btn-destaque"> <img src={process.env.PUBLIC_URL + './logingoogle.png'} alt='' width="30" /> Usando uma conta Google </Button>
                {error && <p>{error.message}</p>}
            </form>
        );
    }
}

class SignInFacebookBase extends Component {
    constructor(props) {
        super(props);

        this.state = { error: null };
    }

    onSubmit = event => {
        this.props.firebase
            .doSignInWithFacebook()
            .then(socialAuthUser => {

                this.props.firebase
                    .user(socialAuthUser.user.uid)
                    .set({
                        username: socialAuthUser.user.displayName,
                        email: socialAuthUser.user.email,
                        url: socialAuthUser.user.photoURL,
                    })
                    .then(() => {
                        this.setState({ error: null });
                        this.props.history.push(ROUTES.MEUS_DADOS);
                    })

            })
            .catch(error => {
                this.setState({ error });
                this.props.history.push(ROUTES.MEUS_DADOS);
            });

        event.preventDefault();
    };

    render() {
        const { error } = this.state;

        return (
            <form onSubmit={this.onSubmit}>
                <Button outline color="primary btn-destaque"> <img src={process.env.PUBLIC_URL + '/loginfacebook.png'} alt='' width="30" /> Usando uma conta Facebook </Button>

                {error && <p>{error.message}</p>}
            </form>
        );
    }
}

class SignInFormBase extends Component {
    constructor(props) {
        super(props);

        this.state = { ...INITIAL_STATE };
    }

    onSubmit = event => {
        const { email, password } = this.state;

        this.props.firebase
            .doSignInWithEmailAndPassword(email, password)
            .then(() => {
                this.setState({ error: null });
                this.props.history.push(ROUTES.MEUS_DADOS);
            })
            .catch(error => {
                console.log("erro -> login" + JSON.stringify(error));
                this.setState({ error });
            });

        event.preventDefault();
    };

    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    render() {
        const { email, password, error } = this.state;

        const isInvalid = password === '' || email === '';

        return (
            <form onSubmit={this.onSubmit}>
                <Row form>
                    <Col md={5}>
                        <FormGroup>
                            <Input type="email"
                                name="email"
                                value={email}
                                onChange={this.onChange}
                                placeholder="e-mail" />
                        </FormGroup>
                    </Col>
                    <Col md={5}>
                        <FormGroup>
                            <Input type="password"
                                name="password"
                                id="examplePassword"
                                value={password}
                                onChange={this.onChange}
                                placeholder="Senha" />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <Button disabled={isInvalid} type="submit" color="primary">Entrar</Button>
                    </Col>
                </Row>
                <Row>
                    {error &&
                        error.code == "auth/wrong-password" &&
                        <p className="texto-branco">Senha ou usuário não cadastrado</p>}
                    {error &&
                        error.code == "auth/user-not-found" &&
                        <p className="texto-branco">Usuário não cadastrado</p>}
                    }
                </Row>
            </form>
        );
    }
}

const SignInForm = compose(
    withRouter,
    withFirebase,
)(SignInFormBase);

const SignInGoogle = compose(
    withRouter,
    withFirebase,
)(SignInGoogleBase);

const SignInFacebook = compose(
    withRouter,
    withFirebase,
)(SignInFacebookBase);


export default SignInPage;

export { SignInGoogle, SignInFacebook, SignInForm };